const o = {
  bg: "error"
}, n = {
  ml: "auto",
  mr: -1,
  flexShrink: 0
}, r = {
  color: "white",
  bg: "transparent",
  "&": (t) => ({
    ...t.hover({
      bg: "transparent"
    })
  }),
  "&:focus, &:active": {
    bg: "transparent"
  }
}, c = {
  px: 1
}, e = {
  pt: 2
};
export {
  r as actionIconButton,
  c as collapsible,
  e as collapsibleContent,
  o as errorToast,
  n as rightActions
};
